import { AbstractService } from '@uniqoders/sdk';

export default class StoryCategoryService extends AbstractService {
  /**
   * Retrieve all CMS story categories for an agency
   */
  public listCmsStoryCategories(agency: string, params: Record<string, any> = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/story-categories', { agency }),
      params,
    });
  }

  /**
   * Retrieve a single CMS story category
   */
  public getCmsStoryCategory(agency: string, categoryId: number, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/story-categories/{categoryId}', { agency, categoryId }),
      params,
      headers,
    });
  }

  /**
   * Create a new CMS story category
   */
  public createCmsStoryCategory(agency: string, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/story-categories', { agency }),
      data,
    });
  }

  /**
   * Update an existing CMS story category
   */
  public updateCmsStoryCategory(agency: string, categoryId: number, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'patch',
      url: this.buildPath('/v2/{agency}/cms/story-categories/{categoryId}', { agency, categoryId }),
      data,
    });
  }

  /**
   * Delete a CMS story category
   */
  public deleteCmsStoryCategory(agency: string, categoryId: number): Promise<any> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/v2/{agency}/cms/story-categories/{categoryId}', { agency, categoryId }),
    });
  }
}
